import React from 'react'

const OpeningStatus = ({ placeName, openingTimes, currentTime }) => {
  console.log('OpeningStatus placeName:', placeName)

  // Format place name for display
  const formatPlaceName = (name) => {
    if (!name) return ''
    return name.split('_').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  // Check if currently open
  const isOpen = () => {
    if (!openingTimes || openingTimes.closed) {
      return false
    }

    const currentTimeStr = currentTime.toTimeString().slice(0, 5) // HH:MM format

    // Check if any place times include the current time
    return openingTimes.places?.some(place => {
      const opensAt = place.opens_at
      const closesAt = place.closes_at
      return opensAt <= currentTimeStr && currentTimeStr < closesAt
    }) || false
  }

  // Get closing time for currently open place
  const getClosingTime = () => {
    if (!openingTimes || !openingTimes.places) return null

    const currentTimeStr = currentTime.toTimeString().slice(0, 5)

    const openPlace = openingTimes.places.find(place => {
      const opensAt = place.opens_at
      const closesAt = place.closes_at
      return opensAt <= currentTimeStr && currentTimeStr < closesAt
    })

    return openPlace?.closes_at
  }

  // Get next opening time
  const getNextOpening = () => {
    if (openingTimes?.next_opening) {
      return openingTimes.next_opening
    }
    return null
  }

  const open = isOpen()
  const closingTime = getClosingTime()
  const nextOpening = getNextOpening()

  // Check if next opening is today
  const getNextOpeningDayText = () => {
    if (!nextOpening) return ''

    const today = currentTime.toISOString().split('T')[0]
    const nextOpeningDate = nextOpening.date

    return nextOpeningDate === today ? 'today' : nextOpening.day_name
  }

  return (
    <div className="p-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-5xl font-bold mb-2">
            {formatPlaceName(placeName)}
          </h1>
          <div className="text-3xl">
            {open ? (
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full"></span>
                <span className="text-green-400">
                  Open{closingTime && ` until ${closingTime}`}
                </span>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center w-6 h-6 bg-red-500 rounded-full"></span>
                <span className="text-red-400">
                  Closed
                  {nextOpening && (
                    <span className="text-gray-400 ml-2">
                      • Opens {nextOpening.opens_at} {getNextOpeningDayText()}
                    </span>
                  )}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="text-right">
          <div className="text-4xl font-mono">
            {currentTime.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
          <div className="text-xl text-gray-400">
            {currentTime.toLocaleDateString('en-GB', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpeningStatus
